"use client";
import { HTMLAttributes, PropsWithoutRef } from "react";
import { cn } from "@/lib/helpers/utils";
import { SunIcon } from "@/app/icons/icon-sun";
import { MoonIcon } from "@/app/icons/icon-moon";
import { useTheme } from "@/app/providers/QuranThemeProvider";
import { DesktopIcon } from "@radix-ui/react-icons";
import { Tabs, TabsList } from "@/components/ui/tabs";

import { CustomTabsTriggers } from "@/components/ui/custom-tab-triggers";

const ColorMode = ({
  className,
  showText = true,
  ...props
}: PropsWithoutRef<HTMLAttributes<HTMLDivElement>> & {
  showText?: boolean;
}) => {
  const { colorMode } = useTheme();

  const tabs = [
    { id: 1, name: "light", icon: <SunIcon className="w-4 h-4 z-10" /> },
    {
      id: 2,
      name: "system",
      icon: <DesktopIcon className="w-4 h-4 z-10" />,
    },
    { id: 3, name: "dark", icon: <MoonIcon className="w-4 h-4 z-10" /> },
  ];

  return (
    <div className={cn("grid grid-cols-1 w-full", className)} {...props}>
      <Tabs
        defaultValue={colorMode}
        className="w-full flex flex-col justify-center flex-wrap"
      >
        <TabsList className="grid grid-cols-3 relative h-12">
          <CustomTabsTriggers
            showText={showText}
            className="w-1/3 top-[0.4em]"
            tabList={tabs}
            tabIndicatorId="color-mode-indicator"
          />
        </TabsList>
      </Tabs>
    </div>
  );
};
export default ColorMode;
